import React, { useEffect, useState } from "react";
import { Truck } from "lucide-react";
import { MoonMark as Moon } from "@/components/MoonMark";
import { api } from "@/lib/api";

export const AnnouncementBar = () => {
  const [messages, setMessages] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/settings").then((r) => {
      let list = (r.data.announcements || [])
        .filter((a) => a.enabled && (a.text || "").trim())
        .map((a) => a.text.trim());
      if (list.length === 0 && r.data.announcement_enabled && r.data.announcement_text) {
        list = [r.data.announcement_text];
      }
      setMessages(list);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (messages.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % messages.length), 5000);
    return () => clearInterval(t);
  }, [messages]);

  if (messages.length === 0) return null;
  const text = messages[idx % messages.length];

  return (
    <div className="w-full bg-gold text-black overflow-hidden" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2.5 min-h-[34px]">
        <Moon className="w-3.5 h-3.5 shrink-0" strokeWidth={2} />
        <p key={idx} className="font-body uppercase tracking-[0.2em] text-[11px] sm:text-xs font-medium text-center announce-fade" data-testid="announcement-text">
          {text}
        </p>
        <Truck className="w-3.5 h-3.5 hidden sm:block shrink-0" strokeWidth={2} />
      </div>
      <style>{`@keyframes announceFade{from{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:translateY(0)}}.announce-fade{animation:announceFade .5s ease}`}</style>
    </div>
  );
};

export default AnnouncementBar;
